<template>
  <basic-container>
    <el-form
      :model="searchForm"
      ref="searchFormRef"
      label-width="100px"
      label-suffix=":"
      v-show="searchBoxFlag"
    >
      <el-row :gutter="24">
        <el-col :span="6">
          <el-form-item label="服务网点" prop="nursinghomeId">
            <el-select
               :disabled="model==='view'" v-model="searchForm.nursinghomeId"
              style="width: 100%"
              placeholder="服务网点"
              @change="nursinghomeIdChange"
            >
              <el-option
                v-for="item in nursinghomeIdList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="设备类型" prop="deviceTypeId">
            <el-select  :disabled="model==='view'" v-model="searchForm.deviceTypeId" style="width: 100%" placeholder="设备类型">
              <el-option
                v-for="item in deviceTypeIdList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="6">
          
          <el-form-item label="身份证号" prop="idNumber">
            <el-input
              clearable
               :disabled="model==='view'" v-model="searchForm.idNumber"
              placeholder="身份证号"
              maxlength="100"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="用户姓名" prop="name">
            <el-input
              clearable
               :disabled="model==='view'" v-model="searchForm.name"
              placeholder="用户姓名"
              maxlength="100"
            ></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item label="设备状态" prop="deviceStatus">
            <el-select  :disabled="model==='view'" v-model="searchForm.deviceStatus" style="width: 100%" placeholder="设备状态">
              <el-option
                v-for="item in deviceStatuseList"
                :key="item.dictKey"
                :label="item.dictValue"
                :value="item.dictKey"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>



        <el-col :span="6">
          <el-form-item label="在线状态" prop="onlineStatus">
            <el-select  :disabled="model==='view'" v-model="searchForm.onlineStatus" style="width: 100%" placeholder="在线状态">
              <el-option
                v-for="item in onlineStatusList"
                :key="item.dictKey"
                :label="item.dictValue"
                :value="item.dictKey"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>

        

        <el-col :span="6">
          <el-form-item label="设备标识ID" prop="deviceIdentificationId">
            
            <el-input
              clearable
               :disabled="model==='view'" v-model="searchForm.deviceIdentificationId"
              placeholder="设备标识ID"
              maxlength="100"
            ></el-input>
          </el-form-item>
        </el-col>


          <el-col :span="6">
            <el-form-item label="发放方式" prop="releaseMode">
              <el-select  :disabled="model==='view'" v-model="searchForm.releaseMode" style="width: 100%" placeholder="发放方式">
                <el-option
                  v-for="item in provideList"
                  :key="item.dictKey"
                  :label="item.dictValue"
                  :value="item.dictKey"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>


        <el-col :span="24">
          <div style="float: right">
            <el-button type="primary" icon="el-icon-search" @click="searchRecord" size="small">
              搜索
            </el-button>
            <el-button icon="el-icon-delete" @click="searchClear" size="small"> 清空 </el-button>
          </div>
        </el-col>
      </el-row>
    </el-form>
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      ref="crud"
      @on-load="onLoad"
      @current-change="currentChange"
      @size-change="sizeChange"
      @refresh-change="onLoad"
      @selection-change="selectionChange"
    >
      <template slot="menuRight">
        <searchFromShow
          :searchBoxFlag.sync="searchBoxFlag"
          :removeHeight="searchHeight"
          :option="option"
          reduceHeight="20"
          :refOption="$refs.crud"
        ></searchFromShow>
      </template>

      <template slot="menuLeft">
        <el-button v-if="permissionList.addBtn" type="primary" size="small" @click="addNursingForm"> 新 增</el-button>
      </template>
      <template slot-scope="scope" slot="menu">
        <el-button v-if="permissionList.viewBtn" type="text" size="small" @click="viewRecord(scope.row)">查看 </el-button>
        <el-button v-if="permissionList.editBtn" type="text" size="small" @click="editRecord(scope.row)">编辑 </el-button>

        <el-button v-if="permissionList.delBtn" type="text" size="small" @click="deleteFun(scope.row.id)">删除 </el-button>
        <el-button v-if="permissionList.switchBtn&&scope.row.deviceStatus == 2 " type="text" size="small" @click="switchFun(scope.row.id,scope.row.deviceStatus)">停用 </el-button>
        <el-button v-if="permissionList.switchBtn&&scope.row.deviceStatus == 1 " type="text" size="small" @click="switchFun(scope.row.id,scope.row.deviceStatus)">启用 </el-button>

        <el-button v-if="!permissionList.healthBtn"  type="text" size="small" @click="openHealthInfo(scope.row)">健康数据 </el-button>
      </template>
    </avue-crud>

    <itemList ref="itemList"></itemList>
    <hr-dialog
      :title="formModel==='add'?'新增':formModel==='edit'?'编辑':'查看'"
      :allowFull="false"
      width="60%"
      :visible.sync="nursingFormVisible"
    >
      <template slot="body">
        <braceletForm
          :model="formModel"
          :row="formRow"
          @cancle="recordCancle"
          v-if="nursingFormVisible"
          @success="recordSuccess"
          :nursinghomeId="this.searchForm.nursinghomeId"
        ></braceletForm>
      </template>
    </hr-dialog>
    <hr-dialog
      title="健康档案"
      :allowFull="false"
      width="60%"
      :visible.sync="healthInfoVisible"
    >
      <template slot="body">
        <HealthInfo
:row="formRow"
          v-if="healthInfoVisible"></HealthInfo>
      </template>
    </hr-dialog>
  </basic-container>
</template>
  <script>
import { getProjectList } from '@/api/crmedical/project/project';
import { stockWarnPage, getWarehouseList, stockWarnDelete } from '../api/serveItemManage.js';
import braceletForm from './braceletForm.vue';
import HealthInfo from './healthInfo.vue';
import { getDictionary } from '@/api/common.js';
import searchFromShow from '@/components/search-form-show/index';
import { mapGetters } from 'vuex';
import { getNursinghome, getWristbandPage, getDeviceTypeList, wristbandRemove, deviceStart, deviceStop } from '../api/serveItemManage';
export default {
  components: { searchFromShow, braceletForm ,HealthInfo},
  data() {
    return {
      healthInfoVisible: false,
      editVisible: false,
      formModel: 'add',
      isImportDialogShow: false,
      settingTotalWarnVisible: false,
      nursingFormVisible: false,
      printVisible: false,
      addOrderVisible: false,
      alarmRuleVisible: false,
      alarmRuleTittle: '编辑',
      alarmRuleModel: 'view',
      rowInfo: {},
      searchForm: {
        nursinghomeId: '',
        warehouseId: '',
        type: '0',
        consumableCode: '',
        consumableName: '',
        specification: '',
        upWarnFlag: 'false',
        downWarnFlag: 'false',
      },

      projectList: [],

      provideList: [
        {
          dickey: '0',
          dicvalue: '购买',
        },
        {
          dickey: '1',
          dicvalue: '免费',
        },
      ],
      option: {
        selection: false,
        select: true,
        index: true,
        indexLabel: '#',
        page: true,
        height: 'auto',
        calcHeight: 'auto',
        align: 'left',
        menu: true,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        border: true,
        column: [
         
          {
            label: '设备标识ID',
            prop: 'deviceIdentificationId',
          },
         
          {
            label: '设备类型',
            prop: 'deviceTypeName',
          },
         
          {
            label: 'SIM卡号',
            prop: 'simCard',
          },
          {
            label: '用户姓名',
            prop: 'name',
          },
          {
            label: '身份证号',
            prop: 'idNumber',
          },
          {
            label: '联系方式',
            prop: 'tel',
          },
          {
            label: '发放方式',
            prop: 'releaseMode',
            dicUrl: '/api/blade-system/dict/dictionary?code=nursinghome_release_mode_type',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
          },
          {
            label: '开通时间',
            prop: 'createTime',
          },
          {
            label: '在线状态',
            prop: 'onlineStatus',
            dicUrl: '/api/blade-system/dict/dictionary?code=nursinghome_online_status_type',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
          },
          {
            label: '设备状态',
            prop: 'deviceStatus',
            dicUrl: '/api/blade-system/dict/dictionary?code=nursinghome_device_statuse_type',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
          },
        ],
      },
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      loading: false,
      searchBoxFlag: true,
      searchHeight: '',
      selectionList: [],
      recordIds: [],
      canteenList: [],
      warehouseList: [],
      selectionIds: '',
      formRow: {},
      nursinghomeIdList: [],
      deviceTypeIdList:[],
      onlineStatusList:[],
      deviceStatuseList:[],
    };
  },
  created() {
    this.initData();
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        switchBtn: this.vaildData(this.permission.bracelet_switch, false),
        viewBtn: this.vaildData(this.permission.deviceManage_view, false),
        addBtn: this.vaildData(this.permission.deviceManage_add, false),
        editBtn: this.vaildData(this.permission.deviceManage_edit, false),
        delBtn: this.vaildData(this.permission.deviceManage_del, false),
        healthBtn:this.vaildData(this.permission.device_healthInfo, false),
      };
    },
  },
  mounted() {
    this.calcHeight();
  },
  watch:{
    '$route.path':function(newVal,oldVal){
          // console.log(newVal + '---' +  oldVal);
          if(newVal === '/nursingHome/deviceManage/index'){
             this.$refs.crud.$refs.table.doLayout()
          }
        }
  },
  methods: {
    openHealthInfo(row){
      this.formRow = row;
      this.healthInfoVisible = true
    },
    switchFun(id,status){
      if(status==1){
        deviceStart({id:id}).then(res=>{
          this.$message.success('操作成功！');
          this.onLoad();
        })
      }
      
      if(status==2){
        deviceStop({id:id}).then(res=>{
          this.$message.success('操作成功！');
          this.onLoad();
        })
      }
      
    },
    openItemDetail(row) {
      this.$refs.itemList.openItemListOnload(row.id, row.name);
    },
    addNursingForm() {
      this.formModel = 'add';
      this.nursingFormVisible = true;
    },
    importSuccess() {
      this.isImportDialogShow = false;
      this.onLoad();
    },

    deleteFun(id) {
      this.$confirm(' 是否删除该数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          wristbandRemove(id).then((re) => {
            this.$message.success('删除成功');
            this.onLoad();
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消操作',
          });
        });
    },

    editRecord(row) {
      this.formRow = row;
      this.formModel = 'edit';
      this.nursingFormVisible = true;
      this.editVisible = true;
    },
    settingTotalWarn() {
      this.formModel = 'add';
      this.settingTotalWarnVisible = true;
    },
    importFun() {
      this.isImportDialogShow = true;
    },
    nursingForm() {
      this.formModel = 'add';
      this.nursingFormVisible = true;
    },

    recordCancle() {
      this.editVisible = false;
      this.nursingFormVisible = false;
      this.settingTotalWarnVisible = false;
    },
    recordSuccess() {
      this.editVisible = false;
      this.nursingFormVisible = false;
      this.settingTotalWarnVisible = false;
      this.onLoad();
    },
    viewRecord(row) {
      this.formRow = row;
      this.formModel = 'view';
      this.nursingFormVisible = true;
      this.editVisible = true;
    },

    addRecord() {
      this.alarmRuleTittle = '新增';
      this.alarmRuleVisible = true;
      this.rowInfo = {
        nursinghomeId: this.searchForm.nursinghomeId,
      };
      this.alarmRuleModel = 'add';
    },

    stopCanteen() {
      this.alarmRuleVisible = true;
    },
    nursinghomeIdChange(nursinghomeId) {
      
          
          getDeviceTypeList({id: nursinghomeId}).then((res)=>{
            this.deviceTypeIdList = res.data;
          });
      // this.searchForm.warehouseId = '';
      
      // this.warehouseList = [];
      // getWarehouseList({ nursinghomeId: this.searchForm.nursinghomeId }).then((res) => {
      //   this.warehouseList = res.data;
      // });
      // //  getCanteenName({nursinghomeId:nursinghomeId}).then(res=>{
      // //           this.canteenList = res.data
      // //        })
      // this.getDeptList(this.searchForm.nursinghomeId);
      // this.getCanteen(this.searchForm.nursinghomeId);
    },
    searchRecord() {
      this.page.currentPage = 1;
      if (this.searchForm.upWarnFlag == '') {
        this.searchForm.upWarnFlag = false;
      }
      if (this.searchForm.downWarnFlag == '') {
        this.searchForm.downWarnFlag = false;
      }
      this.onLoad();
    },
    searchClear() {
      this.tool.clearObject(this.searchForm, 'nursinghomeId');
      this.searchForm.type = '0';
    },

    calcHeight() {
      this.searchHeight = this.$refs.searchFormRef.$el.clientHeight;
      this.option.height = this.bodyHeight - this.searchHeight - 279 - 20;
    },
    initData() {
      getNursinghome().then((res) => {
        this.nursinghomeIdList = res.data;
        if (this.nursinghomeIdList.length > 0) {
          this.$set(this.searchForm, 'nursinghomeId', this.nursinghomeIdList[0].id);
          // getWarehouseList({ nursinghomeId: this.searchForm.nursinghomeId }).then((res) => {
          //   this.warehouseList = res.data;
          // });
          
          getDeviceTypeList({id: this.searchForm.nursinghomeId}).then((res)=>{
            this.deviceTypeIdList = res.data;
          });
          this.onLoad();
        }
      });
      getDictionary('nursinghome_online_status_type').then((res) => {
        this.onlineStatusList = res.data;
      });
      getDictionary('nursinghome_device_statuse_type').then((res) => {
        this.deviceStatuseList = res.data;
      });
      getDictionary('nursinghome_release_mode_type').then((res) => {
        this.provideList = res.data;
      });
    },

    onLoad() {
      if (this.searchForm.nursinghomeId != '') {
        this.loading = true;

        getWristbandPage(
          Object.assign(
            {},
            { current: this.page.currentPage, size: this.page.pageSize },
            this.searchForm
          )
        )
          .then(({ data }) => {
            this.data = data.records;
            this.page.total = data.total;
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
      }
    },
  },
};
</script>
  
  <style scoped>
::v-deep .avue-crud__right {
  display: flex;
}
/deep/ .el-drawer__body {
  overflow: scroll !important;
}
::v-deep .avue-crud .el-form-item {
  display: block;
}

.money {
  text-align: right;
}
.txtOver {
  display: -webkit-box;
  overflow: hidden; /*超出隐藏*/
  text-overflow: ellipsis; /*隐藏后添加省略号*/
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
</style>
  <style>
#alarmRule > div > div.el-dialog__body {
  height: calc(100% - 100px);
}
</style>
  